import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTiktok, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const footerSections = [
    {
        title: "CHI SIAMO",
        links: [
            { label: "La nostra storia", href: "https://www.psicopatici.com/about-us" },
            { label: "Dicono di noi", href: "https://www.psicopatici.com/press" },
            { label: "Novità", href: "https://www.psicopatici.com/news" }
        ]
    },
    {
        title: "ASSISTENZA",
        links: [
            { label: "Contatti e supporto", href: "https://www.psicopatici.com/contact-us" },
            { label: "FaQs", href: "https://www.psicopatici.com/faqs" },
            { label: "Sizeyou", href: "https://www.psicopatici.com/size-you-info-page" }
        ]
    },
    {
        title: "IL NOSTRO STORE",
        links: [
            { label: "Donna", href: "https://www.psicopatici.com/product-categories/donna" },
            { label: "Uomo", href: "https://www.psicopatici.com/product-categories/uomo" },
            { label: "Unisex", href: "https://www.psicopatici.com/product-categories/unisex" },
            { label: "Bestseller", href: "https://www.psicopatici.com/product-categories/bestseller" },
            { label: "Collezione SS26", href: "https://www.psicopatici.com/product-categories/nuovi-arrivi" },
            { label: "Gift Card", href: "https://www.psicopatici.com/gift-card" }
        ]
    },
    {
        title: "INFORMAZIONI LEGALI",
        links: [
            { label: "Termini e condizioni", href: "https://legal.psicopatici.com/terms-and-conditions" },
            { label: "Cookie Policy", href: "https://legal.psicopatici.com/cookie-policy" },
            { label: "Privacy Policy", href: "https://legal.psicopatici.com/privacy-policy" }
        ]
    },
    {
        title: "PROGRAMMI",
        links: [
            { label: "Partner Content creator", href: "https://partner.psicopatici.com/" },
            { label: "Partner Negozi", href: "https://partner.psicopatici.com/totemtouch" }
        ]
    }
];

function Footer() {
    const currentYear = new Date().getFullYear();

    // Stato di React per gestire l'apertura dell'accordion in modo infallibile
    const [openSection, setOpenSection] = useState(null);

    const toggleAccordion = (idx) => {
        // Se clicco sulla sezione già aperta, la chiudo (null), altrimenti apro quella cliccata
        setOpenSection(openSection === idx ? null : idx);
    };

    const renderLink = (link) => {
        const linkClasses = "text-white text-decoration-none footer-hover-link d-block mb-2";

        return (
            <a href={link.href} target="_blank" rel="noreferrer" className={linkClasses} style={{ fontSize: '14px' }}>
                {link.label}
            </a>
        );
    };

    return (
        <>
            <style>{`
                .footer-hover-link { transition: color 0.2s ease-in-out; }
                .footer-hover-link:hover { color: #ffffff !important; }
                
                .footer-dark-accordion .accordion-item { background-color: transparent; border-bottom-color: #333 !important; }
                .footer-dark-accordion .accordion-button {
                  background-color: transparent;
                  color: #ffffff;
                  padding-left: 0;
                  padding-right: 0;
                  box-shadow: none;
                }
                .footer-dark-accordion .accordion-button:not(.collapsed) {
                  color: #ffffff;
                  background-color: transparent;
                  box-shadow: none;
                }
                .footer-dark-accordion .accordion-button::after {
                  filter: invert(1) grayscale(100%) brightness(200%);
                }
                
                /* Transizione fluida per l'apertura manuale */
                .custom-collapse {
                    transition: height 0.3s ease;
                    overflow: hidden;
                }

                /* LOGICA RIGIDA PER MOSTRARE/NASCONDERE DESKTOP E MOBILE */
                .desktop-footer-grid {
                    display: none !important;
                }
                .mobile-footer-accordion {
                    display: block !important;
                }

                @media (min-width: 768px) {
                    .desktop-footer-grid {
                        display: block !important;
                    }
                    .mobile-footer-accordion {
                        display: none !important;
                    }
                }
            `}</style>

            <footer className="pt-5" style={{ backgroundColor: '#0a0a0a', color: '#ffffff' }}>

                {/* Logo Centrale Superiore */}
                <div className="d-flex justify-content-center mb-5 w-100">
                    <Link to="/">
                        <img
                            style={{ width: "40px", height: "auto" }}
                            alt="Logo Psicopatici"
                            src="https://cdn.psicopaticiservice.com/logo/favicon-white.png"
                        />
                    </Link>
                </div>

                {/* --- VERSIONE DESKTOP (5 Colonne) --- */}
                <div className="w-100 mx-auto px-4 desktop-footer-grid" style={{ maxWidth: '1400px' }}>
                    <div className="row text-center">
                        {footerSections.map((section, idx) => (
                            <div key={idx} className="col">
                                <h3 className="fw-bold text-uppercase mb-4" style={{ fontSize: '14px', letterSpacing: '1px' }}>
                                    {section.title}
                                </h3>
                                <ul className="list-unstyled">
                                    {section.links.map((link, linkIdx) => (
                                        <li className='text-white' key={linkIdx}>
                                            {renderLink(link)}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* --- VERSIONE MOBILE (Accordion Gestito con React) --- */}
                <div className="w-100 px-4 mobile-footer-accordion">
                    <div className="accordion accordion-flush footer-dark-accordion">
                        {footerSections.map((section, idx) => {
                            const isOpen = openSection === idx;
                            return (
                                <div key={idx} className="accordion-item border-bottom">
                                    <h2 className="accordion-header">
                                        <button
                                            className={`accordion-button fw-bold text-uppercase ${isOpen ? '' : 'collapsed'}`}
                                            type="button"
                                            onClick={() => toggleAccordion(idx)}
                                            style={{ fontSize: '14px' }}
                                        >
                                            {section.title}
                                        </button>
                                    </h2>
                                    <div className={`custom-collapse ${isOpen ? 'd-block' : 'd-none'}`}>
                                        <div className="accordion-body px-0 pt-2 pb-3">
                                            {section.links.map((link, linkIdx) => (
                                                <div key={linkIdx}>
                                                    {renderLink(link)}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Social Icons Centrali */}
                <div className="d-flex justify-content-center align-items-center gap-4 mt-5 mb-4">
                    <a href="https://www.facebook.com/psicopaticiitalia/" target="_blank" rel="noreferrer" className="text-white footer-hover-link">
                        <FaFacebookF size={20} />
                    </a>
                    <a href="https://www.instagram.com/psicopaticiitalia/" target="_blank" rel="noreferrer" className="text-white footer-hover-link">
                        <FaInstagram size={22} />
                    </a>
                    <a href="https://www.tiktok.com/@psicopaticiitalia" target="_blank" rel="noreferrer" className="text-white footer-hover-link">
                        <FaTiktok size={20} />
                    </a>
                    <a href="https://www.linkedin.com/company/psicopaticiitalia" target="_blank" rel="noreferrer" className="text-white footer-hover-link">
                        <FaLinkedinIn size={22} />
                    </a>
                </div>

                {/* Sezione Copyright */}
                <div className="w-100 mt-4 py-4 text-center" style={{ borderTop: '1px solid #333' }}>
                    <div className="container">
                        <p className="mb-0 text-secondary" style={{ fontSize: '14px' }}>
                            © 2025 - {currentYear} All Rights Reserved by <a href="https://www.psicopatici.com/" className="text-white footer-hover-link text-decoration-none">psicopatici.com</a>
                        </p>
                    </div>
                </div>

            </footer>
        </>
    );
}

export default Footer;